import { type KeyboardEvent, type ReactElement, useId } from 'react';
import { Input } from '@/shared/ui';

interface EditorNumberFieldProps {
  readonly label: string;
  readonly value: string;
  readonly onChange: (value: string) => void;
  /** 이 칸만 잠근다. 폼 전체 잠금은 감싸는 fieldset 이 맡는다. */
  readonly disabled?: boolean;
  /** 값은 보이되 고칠 수 없다(그려서 자동 계산되는 치수). */
  readonly readOnly?: boolean;
  readonly placeholder?: string;
  /** Enter·Esc 처럼 칸에서 누른 키. 자동 적용 폼이 적용·되돌리기에 쓴다. */
  readonly onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
  /** 칸을 떠날 때. 자동 적용 폼이 적용에 쓴다. */
  readonly onBlur?: () => void;
}

export const EditorNumberField = ({
  label,
  value,
  onChange,
  disabled = false,
  readOnly = false,
  placeholder,
  onKeyDown,
  onBlur,
}: EditorNumberFieldProps): ReactElement => {
  const id = useId();
  return (
    <label htmlFor={id} className="grid gap-1 text-sm">
      {label}
      <Input
        id={id}
        type="number"
        step="any"
        value={value}
        disabled={disabled}
        readOnly={readOnly}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
      />
    </label>
  );
};
